import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/pro-duotone-svg-icons'
import { faArrowRotateLeft } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { ColorsPalette } from '../../../../config/colors'
import IconButton from '../../../../Components/antd/Buttons/IconButton'

const SchoolPortalSuccessScreen = ({ email, institutionName, onRestart }) => {
  const t = useSelector(selectTranslate)

  return (
    <div className='pd-12 flex-col ai-ctr' style={{ textAlign: 'center' }}>
      <FontAwesomeIcon icon={faCircleCheck} size='3x' color={ColorsPalette.FOREST_GREEN} />
      <h3 className='mt-12'>{t('school_portal.success.title')}</h3>
      <p>{t('school_portal.success.transmitted', { institution: institutionName })}</p>

      <div className='modal-inner-container mt-8 w-100'>
        <p className='m-0'>{t('school_portal.success.tracking')}</p>
        <p className='m-0'><b>{email}</b></p>
      </div>

      <p className='mt-8'>{t('school_portal.success.next')}</p>

      <IconButton
        className='logo-colored-button blue blue-ghost-hover mt-8'
        icon={faArrowRotateLeft}
        text={t('school_portal.success.restart')}
        onClick={onRestart}
      />
    </div>
  )
}

export default SchoolPortalSuccessScreen
